// @flow

import jquery from 'jquery';
import FroalaEditor from 'froala-editor';
import values from 'lodash/values';
import join from 'lodash/join';

import {VIDEO_API} from 'app/urls';
import {postJson} from 'app/utils/request';
import {gt} from 'app/utils/i18n';

// The custom popup is defined inside a plugin (new or existing).
FroalaEditor.PLUGINS.sweetVideos = function (editor) {
  editor.DEFAULTS = jquery.extend(editor.DEFAULTS, {
    sweetprocess: {
      contentType: 'procedure',
      objectId: undefined,
    },
  });

  // eslint-disable-next-line no-underscore-dangle
  function _apiVideoCallback(xhr, $video) {
    $video.replaceWith(`<a href="${xhr.video_url}">${xhr.video_url}</a>`);
    editor.video.hideProgressBar(true);
    editor.events.trigger('contentChanged');
  }

  // eslint-disable-next-line no-underscore-dangle
  function _showErrorMessage(message) {
    editor.video.showProgressBar();
    var $popup = editor.popups.get('video.insert');
    var $layer = $popup.find('.fr-video-progress-bar-layer');
    $layer.addClass('fr-error');
    var $message_header = $layer.find('h3');
    $message_header.text(message);
    editor.events.disableBlur();
    $message_header.focus();
  }

  // eslint-disable-next-line no-underscore-dangle
  function _apiVideoError(error, $video) {
    $video.remove();
    if (error.response && error.response.status >= 500) {
      _showErrorMessage(gt('Server error occurred'));
    } else if (error.response == null && error.data == null) {
      _showErrorMessage(gt('Server error occurred'));
    } else {
      _showErrorMessage(join(values(error.data)));
    }
    editor.events.trigger('contentChanged');
  }

  function videoInsertedListener($video) {
    // Only process uploaded videos (HTML5 video element). URL embeds (YouTube/Vimeo
    // iframes) do not need the backend API - they stay as inline iframes.
    const $videoEl = jquery('video', $video)[0];
    if ($videoEl == null) {
      return;
    }

    const original_url = $videoEl.src;

    postJson(VIDEO_API, {
      content_type: editor.opts.sweetprocess.contentType,
      object_id: editor.opts.sweetprocess.objectId,
      original_url,
    })
      .then((response) => _apiVideoCallback(response, $video))
      .catch((error) => _apiVideoError(error, $video));
  }

  // eslint-disable-next-line no-underscore-dangle
  function _init() {
    editor.events.on('video.inserted', videoInsertedListener);
  }

  // Methods visible outside the plugin.
  return {_init};
};
